import React from "react";
import PublicMainFooter from "components/footers/PublicMainFooter";
import PublicMainNav from "components/navigations/PublicMainNav";

export default function PublicBlueprint(WrappedComponent) {
  return function PublicLayerComponent(props) {
    return (
      <div className="min-height-screen">
        <PublicMainNav />
        <WrappedComponent {...props} />
        <PublicMainFooter />
      </div>
    );
  };
}
